'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _Element = require('./Element');

var _Element2 = _interopRequireDefault(_Element);

var _Swiper = require('./Swiper');

var _Swiper2 = _interopRequireDefault(_Swiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaWrapper = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MediaWrapper, _Component);

  function MediaWrapper(props) {
    (0, _classCallCheck3.default)(this, MediaWrapper);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MediaWrapper.__proto__ || (0, _getPrototypeOf2.default)(MediaWrapper)).call(this, props));

    _this.shouldComponentUpdate = function (nextProps) {
      return nextProps.mediaElementsShown.length !== _this.props.mediaElementsShown.length;
    };

    _this.componentDidUpdate = function (prevProps) {
      if (prevProps.mediaElementsShown.length !== _this.props.mediaElementsShown.length) {
        _this.scrollToBottom();
        _this.stopAllVideos();
      }
    };

    return _this;
  }

  (0, _createClass3.default)(MediaWrapper, [{
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      $("#mediaScrollContainer").animate({ scrollTop: $('#mediaScrollContainer').prop("scrollHeight") }, 1500);
    }
  }, {
    key: 'stopAllVideos',
    value: function stopAllVideos() {

      $('iframe').each(function () {
        if ($(this).get(0).contentWindow !== undefined) {
          $(this).get(0).contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        }
      });

      $('.r5-wraper video').each(function () {
        $(this).get(0).pause();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'mediaWrapper' },
        _react2.default.createElement(
          'div',
          { className: 'wrapper', id: 'mediaScrollContainer' },
          _react2.default.createElement(
            'div',
            { className: 'content' },
            _react2.default.createElement(
              'div',
              { className: 'elements' },
              _react2.default.createElement(
                _reactAddonsCssTransitionGroup2.default,
                { transitionName: '__CHAT_TEMPLATE_MESSAGES_TRANSITION_ELEMENT', transitionEnterTimeout: 55000, transitionLeave: false },
                this.props.mediaElementsShown.map(function (item, i) {
                  //Pintamos con swiper
                  if (item.elements.length > 1) {
                    return _react2.default.createElement(_Swiper2.default, { key: "mediaId-" + item.mediaId, data: item, mediaId: item.mediaId });
                  } else {
                    //Pintamos elemento simple
                    return _react2.default.createElement(_Element2.default, { key: "mediaId-" + item.mediaId, data: { type: item.elements[0].type, src: item.elements[0].src, srcSubtitles: item.elements[0].srcSubtitles, srcPoster: item.elements[0].srcPoster, subtitle: item.elements[0].subtitle, subtitleOn: item.elements[0].subtitleOn, mediaId: item.mediaId, style: item.elements[0].style }, mediaId: item.mediaId });
                  }
                })
              )
            )
          )
        )
      );
    }
  }]);
  return MediaWrapper;
}(_react.Component), _class.propTypes = {
  mediaElementsShown: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    elements: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      type: _react.PropTypes.string,
      src: _react.PropTypes.string,
      subtitle: _react.PropTypes.string
    })),
    srcThumbnail: _react.PropTypes.string,
    title: _react.PropTypes.string,
    mediaId: _react.PropTypes.number
  })).isRequired
}, _temp);
exports.default = MediaWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/MediaWrapper.js
// module id = 794
// module chunks = 0